import React from 'react';
import ApprovedJobsContainer from '../../../../Containers/UserContainer/Jobs/ApprovedJobs';

const ApprovedJobsScreen = () => {
  return <ApprovedJobsContainer />;
};

export default ApprovedJobsScreen;
